import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { SubscriberEmailService } from './subscriber-email.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
// import { DatePicker } from 'primeng/datepicker';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastMessageService } from 'src/app/toastr.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-subscriber-email',
  templateUrl: './subscriber-email.component.html',
  styleUrl: './subscriber-email.component.scss'
})
export class SubscriberEmailComponent {
  email: any;
  subscriberMail: any;
  date: Date | undefined;
  SelectedDate: any;
  approvedANDAHeaders: string[] = [];
  approvedANDAData: any[] = [];
  tentativeANDAHeaders: string[] = [];
  tentativeANDAData: any[] = [];
  counts: Array<{ type: string; count: number }> = [];
  approvedANDASummary: any;
  tentativeANDASummary: any;
  currentDate: any;
  editStates: boolean[] = [];
  saveMailData: any;
  public Editor = ClassicEditor;
  public editorData = '<p>Type your content here...</p>';
  public isEditing: boolean = false; // Editing state
  public editedMail: string = '';
  public config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
      ],
      image: [
        ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
        ['float', ['floatLeft', 'floatRight', 'floatNone']],
        ['remove', ['removeMedia']]
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear'
          ]
        ]
      ]
    },
    height: '500px',
    uploadImagePath: '/api/upload',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['customButtons', ['testBtn']],
      ['view', ['fullscreen', 'codeview', 'help']]
    ],
    fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36', '44', '56', '64', '76', '84', '96'],
    fontNames: ['Arial', 'Times New Roman', 'Inter', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times', 'MangCau', 'BayBuomHep', 'BaiSau', 'BaiHoc', 'CoDien', 'BucThu', 'KeChuyen', 'MayChu', 'ThoiDai', 'ThuPhap-Ivy', 'ThuPhap-ThienAn'],
    codeviewFilter: true,
    codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true
  };
  public form: FormGroup = new FormGroup({
    html: new FormControl('', Validators.required)
  });
  constructor(public toastr: ToastrService, private SubscriberEmailService: SubscriberEmailService, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
  }

  // onDateChange(event: any) {
  //   this.SelectedDate = this.date.toLocaleDateString("es-CL");
  //   console.log(this.SelectedDate);
  //   const userEmail = this.email;
  //   this.SubscriberEmailService.getSubscriberMailData(userEmail, this.SelectedDate).subscribe(response => {
  //     this.subscriberMail = response;
  //     console.log("knfejrnjrs", this.subscriberMail)

  //     if (response.current_date) {
  //       this.currentDate = response.current_date;
  //     }

  //     this.counts = [
  //       { type: "Approved ANDA", count: response.ApprovedANDATotalCount },
  //       { type: "Tentative ANDA", count: response.TentativeANDATotalCount }
  //     ];

  //     // Process Approved ANDA Summary
  //     if (response.ApprovedANDASummary?.length > 0) {
  //       this.approvedANDASummary = response.ApprovedANDASummary;
  //     }

  //     // Process Tentative ANDA Summary
  //     if (response.TentativeANDASummary?.length > 0) {
  //       this.tentativeANDASummary = response.TentativeANDASummary;
  //     }
  //     // Process ApprovedANDAPhase2 data
  //     if (response.ApprovedANDAPhase2?.length > 0) {
  //       this.approvedANDAHeaders = Object.keys(response.ApprovedANDAPhase2[0]); // Extract headers
  //       this.approvedANDAData = response.ApprovedANDAPhase2; // Extract data
  //     }

  //     if (response.TentativeANDAPhase2?.length > 0) {
  //       this.tentativeANDAHeaders = Object.keys(response.TentativeANDAPhase2[0]); // Extract headers
  //       this.tentativeANDAData = response.TentativeANDAPhase2; // Extract data
  //     }
  //   });

  // }

  onDateChange(event: any) {
    if (!this.date) {
      // Handle undefined or null date, reset variables
      this.subscriberMail = null; // Clear subscriberMail if date is not selected
      return;
    }
    this.SelectedDate = this.date.toLocaleDateString("es-CL");
    console.log(this.SelectedDate);
    const userEmail = this.email;
    this.SubscriberEmailService.getSubscriberMailData(userEmail, this.SelectedDate).subscribe(response => {
      this.subscriberMail = response['email_template_data'];
      this.editedMail = this.subscriberMail;
    });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(html);
  }

  enableEditing() {
    this.isEditing = true;
    this.editedMail = this.subscriberMail;
  }

  onEditorChange(updatedContent: string) {
    this.editedMail = updatedContent;
  }

  saveChanges() {
    // this.subscriberMail = this.editedMail;
    const payload = {
      emailContent: this.form.controls.html.value,
      date: this.SelectedDate,
    };

    this.isEditing = false;
    this.saveEditedDataToServer(payload);
  }

  cancelEditing() {
    this.isEditing = false;
  }

  saveEditedDataToServer(payload: any) {
    // console.log('Saving edited data:', payload);
    this.SubscriberEmailService.EditSubscriberMailData(payload).subscribe(response => {
      console.log('Data saved successfully', response);
      this.subscriberMail = response['email_template_data']
      this.toastr.success('Data saved successfully!');
    },
      (error) => {
        console.error('Error saving data', error);
        this.toastr.error('Error saving data. Please try again!');
      });
  }

  sendMail() {
    this.subscriberMail = this.editedMail; // Ensure the edited mail is saved
    const payload = {
      date: this.SelectedDate,
      send_mail: true
    };

    // Disable the send button when mail is being sent
    this.isEditing = false;

    // Call your service to send the mail
    this.sendMailToServer(payload);
  }

  sendMailToServer(payload: any) {
    this.SubscriberEmailService.SaveSubscriberMailData(payload).subscribe(response => {
      console.log('Mail sent successfully', response);
      this.toastr.success('Mail sent successfully!');
    },
      (error) => {
        console.error('Error sending mail', error);
        this.toastr.error('Error sending mail. Please try again!');
      });
  }

}
